export const POLICY_LINK = 'https://www.rshb.ru/natural/privacy-policy'
export const TERMS_LINK = 'https://svoevagro.ru/documents/terms.pdf'
export const ADVERTISING_POLICY_LINK = 'https://www.rshb.ru/natural/advertising-policy'
export const YANDEX_MAPS_API_URL = 'https://api-maps.yandex.ru/2.1/'
export const YANDEX_FORMS_EMBED_URL = 'https://forms.yandex.ru/_static/embed.js'
